import { Modal } from 'antd'

const OrderTrackingModal = (props) => {
    const { orderTrackingModalOpen, setOrderTrackingModalOpen, trackingURL } = props;

    return (
        <Modal
            centered
            open={orderTrackingModalOpen}
            onOk={() => setOrderTrackingModalOpen(false)}
            onCancel={() => setOrderTrackingModalOpen(false)}
            footer={""}
            className='order_tracking_wrapper'
        >
            <div className='absolute_icon_wrapper'>
                <img src={require("../../assets/images/icons/icn_location.svg").default} alt="" loading="lazy" />
            </div>
            <div className='card_content h-100'>
                {trackingURL ?
                    <iframe
                        src={trackingURL}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps Location"
                    /> :
                    <h5 className='starting_heading_center_32'>
                        Order Tracking Data Not Found..
                    </h5>
                }
            </div>
        </Modal>

    )
}

export default OrderTrackingModal